// Pure scheduling helpers. Suggestions are advisory; server-side validation is mandatory.
export const minutesOf = (time = "") => {
  if (!/^([01][0-9]|2[0-3]):[0-5][0-9]$/.test(time)) return NaN;
  const [h, m] = time.split(":").map(Number);
  return h * 60 + m;
};
export const clockOf = (minutes) => `${String(Math.floor(minutes / 60)).padStart(2, "0")}:${String(minutes % 60).padStart(2, "0")}`;
export const occupiesChair = (appointment) => !["faltou", "reagendado"].includes(appointment.status) && !appointment.rescheduled_to;
export const overlaps = (startA, durationA, startB, durationB) => startA < startB + durationB && startB < startA + durationA;
export function findConflicts(appointments = [], candidate, excludeId) {
  const start = minutesOf(candidate.time);
  const duration = Number(candidate.duration);
  if (!candidate.date || !Number.isFinite(start) || !Number.isFinite(duration) || duration <= 0) return [];
  return appointments.filter((a) => a.id !== excludeId && a.date === candidate.date && occupiesChair(a) &&
    overlaps(start, duration, minutesOf(a.time), Number(a.duration) || 30));
}
export function suggestFreeSlots(appointments = [], candidate, options = {}) {
  const { open = 7 * 60, close = 21 * 60, interval = 15, limit = 5 } = options;
  const duration = Number(candidate.duration);
  if (!candidate.date || !Number.isFinite(duration) || duration <= 0) return [];
  const desired = minutesOf(candidate.time);
  const suggestions = [];
  for (let m = open; m + duration <= close; m += interval) {
    if (findConflicts(appointments, { ...candidate, time: clockOf(m) }, candidate.id).length === 0) suggestions.push(m);
  }
  return suggestions.sort((a, b) => Math.abs(a - (Number.isFinite(desired) ? desired : open)) - Math.abs(b - (Number.isFinite(desired) ? desired : open)) || a - b).slice(0, limit).map(clockOf);
}
